const data = [
  { label: 'Mon', barValue: 30, lineValue: 22 },
  { label: 'Tue', barValue: 24, lineValue: 20 },
  { label: 'Wed', barValue: 27, lineValue: 21 },
  { label: 'Thu', barValue: 22, lineValue: 18 },
  { label: 'Fri', barValue: 28, lineValue: 24 }
];
const RoundedBarLineChartConfig = (
  datas = [],
  xKey = 'label',
  barKey = 'barValue',
  lineKey = 'lineValue',
  barLabel = 'Total',
  lineLabel = 'Average',
  color = '#8DAA5B'
) => {
  const useDataZoom = data.length > 20;

  return {
    color: [color],
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params) => {
        const bar = params.find(p => p.seriesName === barLabel);
        const line = params.find(p => p.seriesName === lineLabel);
        return `
          <b>${bar?.name || ''}</b><br/>
          🟩 ${barLabel}: ${bar?.value ?? 0}<br/>
          ◯ ${lineLabel}: ${line?.value ?? 0}
        `;
      }
    },
    legend: {show: false},
    grid: {
      left: 0,
      right: 0,
      bottom: useDataZoom ? 50 : 35,
      top: 20,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: data.map(d => d[xKey]),
      axisLabel: {
        interval: 0,
        rotate: 0
      }
    },
    yAxis: {
      type: 'value',
      name: ''
    },
    dataZoom: useDataZoom
      ? [
        {
          type: 'inside',
          xAxisIndex: 0,
          start: 0,
          end: 40
        },
        {
          type: 'slider',
          show: false,
          xAxisIndex: 0,
          height: 15,
          bottom: 40
        }
      ]
      : [],
    series: [
      {
        name: barLabel,
        type: 'bar',
        barWidth: 20,
        data: data.map(d => d[barKey]),
        itemStyle: {
          color,
          borderRadius: [10, 10, 10, 10]
        },
        z: 1
      },
      {
        name: lineLabel,
        type: 'line',
        data: data.map(d => d[lineKey]),
        symbol: 'circle',
        symbolSize: 10,
        lineStyle: {
          color: '#6D8F30',
          width: 2
        },
        itemStyle: {
          color: '#fff',
          borderColor: '#6D8F30',
          borderWidth: 2
        },
        z: 2
      }
    ]
  };
};

export default RoundedBarLineChartConfig;
